import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  let breadcrumbPath = "";

  return (
    <div
      style={{
        marginBottom: "20px",
        fontSize: "16px",
        textTransform: "capitalize",
      }}
    >
      <Link to="/">Dashboard</Link>
      {pathnames.map((name, index) => {
        breadcrumbPath += `/${name}`;
        const isLast = index === pathnames.length - 1;

        return (
          <span key={breadcrumbPath}>
            {" "}
            /{" "}
            {isLast ? (
              <span
                style={{
                  color: "#999",
                }}
              >
                {name}
              </span>
            ) : (
              <Link to={breadcrumbPath}>{name}</Link>
            )}
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
